import { ArrayInput, SimpleFormIterator } from "react-admin";
import { SettingsPage, SettingsUpdate } from "./settingUpdate";
import { ArtistReferenceInput } from "./artists";

export const OnboardingSuggestedArtists = () => {
    return (
        <SettingsPage title="Onboarding Suggested Artists">
            <SettingsUpdate url="/cms/onboarding_artists">
                <p>Artists shown during onboarding</p>
                <ArrayInput source="artist_ids" fullWidth label="Suggested artists">
                    <SimpleFormIterator inline>
                        <ArtistReferenceInput />
                    </SimpleFormIterator>
                </ArrayInput>
            </SettingsUpdate>
        </SettingsPage>
    );
};
